import React from 'react';
import ActionButton from '../../../../elements/ActionButton/ActionButton';
import Link from '../../../../elements/Link';
import SafeImage from '../../../../elements/SafeImage';
import { bestTextColor } from '../../../../../misc/colorUtils';

export default class EventHomeScreenButton extends React.Component {
    render() {
        var { button, event } = this.props;

        if (button.is_text_button || !button.image_url) {
            const bgColor = button.background_color || event.settings.secondary_color;
            const textColor = bgColor ? bestTextColor(bgColor, event.settings.primary_color) : undefined;
            return (
                <>
                    <ActionButton
                        secondary
                        small
                        next
                        color={bgColor}
                        style={{ color: textColor }}
                        nextColor={textColor}
                        {...getDirectoryLinkProps(event, button)}
                    >
                        {button.name}
                    </ActionButton>
                </>
            );
        } else if (button.image_url) {
            return (
                <Link {...getDirectoryLinkProps(event, button)}>
                    <SafeImage
                        src={button.image_url}
                        style={{
                            width: '100%',
                        }}
                    />
                </Link>
            );
        } else {
            console.warn('Unknown button type: ', button);
        }
        return null;
    }
}

export function getDirectoryLinkProps(event, item) {
    if (item.is_sponsor) {
        return {
            href: ['/events', event.id, 'sponsor', item.id].join('/'),
        };
    } else {
        return {
            href: ['/events', event.id, 'content', item.id].join('/'),
        };
    }
}
